<script>
  export default {
    props: {
      trigger: {
        type: String,
        default: 'click'
      },

      placement: {
        type: String,
        default: 'bottom-end'
      },

      transfer: {
        type: Boolean,
        default: true
      }
    },

    render: function(h) {
      return h(
        'Dropdown',
        {
          class: 'zorra-dropdown',
          props: {
            trigger: this.trigger,
            placement: this.placement,
            transfer: this.transfer,
            transferClassName: 'zorra-dropdown-transfer'
          }
        },
        [
          h('a', { href: '#' }, '• • •'),
          h(
            'DropdownMenu',
            {
              slot: 'list',
              class: ['zorra-dropdown-menu']
            },
            [this.$slots.default.filter(f => f.tag).map(node => h('DropdownItem', {}, [node]))]
          )
        ]
      );
    }
  };
</script>

<style lang="scss">
  .zorra-dropdown {
    .ivu-dropdown-rel {
      a {
        color: #c4ccd6;
        letter-spacing: -1px;
        font-size: 12px;

        &:hover {
          color: #2196f3;
          text-decoration: none;
        }
      }
    }
  }

  .zorra-dropdown-transfer {
    &[x-placement='bottom-end'] {
      margin-top: -20px;
    }
  }

  .zorra-dropdown-menu {
    margin-bottom: 0;

    .ivu-dropdown-item {
      padding: 0;

      & > .dropdown-item-icon {
        margin: 0;
        line-height: normal;
        clear: both;
        color: $text-color;
        font-size: 14px !important;
        white-space: nowrap;
        list-style: none;
        cursor: pointer;
        transition: background 0.2s ease-in-out;
        display: inline-block;
        width: 100%;
        text-align: left;
        padding: 12px 24px 12px 48px;
        background-position: 12px center;
        background-repeat: no-repeat;

        @each $icon in $table-controls {
          &--#{$icon} {
            background-image: url(/img/icons/table-controls/#{$icon}.svg);
          }
        }

        &:hover {
          text-decoration: none;
          color: #2196f3;
        }
      }
    }
  }
</style>
